import React, { useCallback, useState } from 'react';
import { Dropdown, DropdownItem } from '../../../dropdown';
import { ReactionDivWrapper, ReactionShow } from './styles';
import {
  MessageReactionInterface,
  UserInterface,
  MessageDetailsInterface
} from '../../../../interfaces/chatMessageInterface';

interface MessageReactionsProps {
  reactions: MessageReactionInterface[] | null;
  reactionCounts: Record<string, number>;
  emojiLoading: boolean;
  workspaceUsers: UserInterface[] | undefined;
  onReactOnMessage: (reactionData: { emoji: string }, message: MessageDetailsInterface) => void;
  message: MessageDetailsInterface;
}

const MessageReactions: React.FC<MessageReactionsProps> = ({
  reactions,
  reactionCounts,
  emojiLoading,
  workspaceUsers,
  onReactOnMessage,
  message
}) => {
  const [hoveredReaction, setHoveredReaction] = useState<string>();

  const handleReactionClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      const type = (e.currentTarget as HTMLElement).getAttribute('data-reaction') || '';
      if (!type) return;
      onReactOnMessage({ emoji: type }, message);
    },
    [onReactOnMessage, message]
  );

  const handleReactionMouseOver = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const type = (e.currentTarget as HTMLElement).getAttribute('data-reaction') || '';
    if (!type) return;
    setHoveredReaction(type);
  }, []);

  if (!reactions || reactions.length === 0) {
    return null;
  }

  return (
    <div className='reaction-container'>
      <Dropdown
        content={
          <ReactionDivWrapper>
            {Object.entries(reactionCounts || {}).map(([type, count]: [string, number]) => (
              <ReactionShow
                role='button'
                isDisabled={emojiLoading}
                data-reaction={type}
                onClick={handleReactionClick}
                key={`reactions_${type}_${count}`}
                onMouseOver={handleReactionMouseOver}>
                <div className='reaction-icon'>{type}</div>
                <p>{count}</p>
              </ReactionShow>
            ))}
          </ReactionDivWrapper>
        }
        trigger='hover'>
        <>
          {Object.entries(reactionCounts || {})?.map(([type]) => (
            <div key={type}>
              {type === hoveredReaction &&
                reactions
                  ?.filter((reaction) => reaction.ReactionType === hoveredReaction)
                  .map((reactedUser) => {
                    const user = workspaceUsers?.find((workspaceUser) => workspaceUser?.id === reactedUser?.UserId);
                    return (
                      <DropdownItem
                        key={`Reactions_type_${reactedUser?.UserId}`}
                        label={user?.name}
                        isAvatar={true}
                        avatarSrc={user?.profile_photo || ''}
                      />
                    );
                  })}
            </div>
          ))}
        </>
      </Dropdown>
    </div>
  );
};

export default React.memo(MessageReactions);
